import resolutionLookup from 'helpers/cameras/resolutionLookup'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import getReverseImagerSize from 'helpers/cameras/getReverseImagerSize'
import getFocalLength from 'helpers/cameras/getFocalLength'
import computeFriendlyTilt from 'helpers/cameras/computeFriendlyTilt'
import ifElse from 'ramda/src/ifElse'
import concat from 'ramda/src/concat'
import converge from 'ramda/src/converge'
import pipe from 'ramda/src/pipe'
import path from 'ramda/src/path'
import { exportWireEndDeviceSelector, exportWireDistanceSelector } from 'selectors/components'

const createHeaders = ({ angleOfView, focalLength, distance, fieldOfView,
  ppf, cameraHeight, sceneHeight, tiltPresentationValue, verticalResolution, horizontalResolution,
  imagerSize, model, unit, isImperial }) => [
  ['Resolution', resolutionLookup({ verticalResolution, horizontalResolution, model })],
  ['HAoV', `${angleOfView.value}°`],
  ['Distance', `${distance.value}${unit}`],
  ['Width', `${fieldOfView.value}${unit}`],
  [isImperial ? 'PPF' : 'PPM', ppf.value],
  ['Imager', `${model ? model.imagerSize : getReverseImagerSize(imagerSize) }`],
  ['Focal Length', getFocalLength({ model, focalLength: focalLength.value })],
  ['Camera Height', `${cameraHeight.value}${unit}`],
  ['Tilt', `${tiltPresentationValue}°`],
  ['Scene Height', `${sceneHeight.value}${unit}`]
]

const modelHeader = name => [['Model', name]]

const addModelNameIfModel = ifElse(
  ({ model }) => !!model,
  pipe(
    path(['model', 'name']),
    modelHeader
  ),
  _ => [['Model', 'Generic Camera']]
)

const craftHeaders = converge(
  concat,
  [
    addModelNameIfModel,
    createHeaders
  ]
)

export default function exportProps(state) {
  const { presentationValues, ui: { isImperial }, cameras, cameraModels } = state
  const camera = getCurrentCamera(cameras)
  const headers = craftHeaders({
    ...camera,
    ...presentationValues,
    tiltPresentationValue: computeFriendlyTilt({ ...camera }),
    unit: isImperial ? 'ft' : 'm',
    isImperial
  })

  const model = camera.model && cameraModels.find(m => m.id === camera.model.id)
  const distanceResult = exportWireDistanceSelector(state)

  return Object.assign(
    {},
    {
      firstRow: headers.slice(0, 2),
      secondRow: headers.slice(2, 6),
      thirdRow: headers.slice(6),
      networkCloset: exportWireEndDeviceSelector(state),
      imagerId: camera.imagerId,
      isImperial
    },
    model && { imageUrl: model.image_url },
    distanceResult && { wireDistance: distanceResult.distance, showWarning: distanceResult.showWarning }
  )
}



// WEBPACK FOOTER //
// ./src/components/TopBar/exportProps.js